import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Box, TextField } from '@mui/material';

import {
  ISubmission,
  ISubmissionQuestion,
  createSubmissionOpenEndedAnswer,
} from '../../../../store/SubmissionSlice';
import { TP_COLORS } from '../../../../constants';

type TOpenEndedQuestionAnswerHandlerProps = {
  submissionData: ISubmission;
  selectedQuestion: ISubmissionQuestion;
};

const OpenEndedQuestionAnswerHandler: React.FC<TOpenEndedQuestionAnswerHandlerProps> = ({
  selectedQuestion,
  submissionData,
}) => {
  const dispatch = useDispatch();
  const params = useParams();

  // State
  const [openEndedAnswer, setOpenEndedAnswer] = useState<string>('');

  useEffect(() => {
    if (selectedQuestion && selectedQuestion.openEnded?.answer) {
      setOpenEndedAnswer(selectedQuestion.openEnded.answer);
    }
  }, []);

  const handleAddOpenEndedAnswer = () => {
    if (
      params.submissionId &&
      selectedQuestion &&
      submissionData.status === 'pending' &&
      openEndedAnswer
    ) {
      dispatch(
        createSubmissionOpenEndedAnswer({
          submissionId: params.submissionId,
          questionId: selectedQuestion.question,
          openEndedAnswer,
        })
      );
    }
  };

  return (
    <Box>
      <TextField
        fullWidth
        multiline
        minRows={10}
        value={openEndedAnswer}
        onChange={(event) => setOpenEndedAnswer(event.currentTarget.value)}
        onBlur={handleAddOpenEndedAnswer}
        disabled={
          selectedQuestion.status === 'skipped' ||
          submissionData.status === 'completed'
        }
        placeholder={
          selectedQuestion.status === 'pending' ? 'Type your answer here' : ''
        }
        InputProps={{
          style: {
            borderRadius: '20px',
            backgroundColor: TP_COLORS.white,
          },
        }}
      />
    </Box>
  );
};

export default OpenEndedQuestionAnswerHandler;
